import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import ImmutableRenderMixin from 'react-immutable-render-mixin';
import {Link} from 'react-router';

export default createReactClass({
  propTypes: {
    kitToken: PropTypes.string.isRequired,
  },

  mixins: [ImmutableRenderMixin],

  render() {
    const {kitToken} = this.props;

    return (
      <Link to={`/kits/${kitToken}/typefaces/new`} className="asset asset-blank asset-typeface asset-typeface-blank br-a link-dashed-none p-xs-a-md">
        <div className="asset-inner">
          <i className="ficon ficon-plus-circle m-xs-r-xs"></i>
          <span className="sr-only">Add</span> Typeface
        </div>
      </Link>
    );
  },
});



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/components/TypefaceCardPlaceholder.js